// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__2PIZX","selected":"Chip_selected__3fqXp"};